if (!customElements.get('motion-herb-directory')) {
  customElements.define('motion-herb-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.loading) {
        if (this.updateVisibility) {
          this.mobileQuery.addEventListener('change', this.updateVisibility);
          this.updateVisibility();
        }
        return;
      }
      this.loading = true;
      this.load();
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.updateVisibility);
    }

    async load() {
      const status = this.querySelector('[role="status"]');
      try {
        const url = new URL(this.dataset.source, window.location.origin);
        url.searchParams.set('section_id', 'motion-herb-audit');
        // Preserve the preview theme when testing an unpublished theme.
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const groups = new Map();
        let page = 1;
        let pages = 1;
        const locale = document.documentElement.lang || 'en';
        do {
          url.searchParams.set('page', String(page));
          const response = await fetch(url);
          if (!response.ok) throw new Error('Herb list unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const dataNode = doc.querySelector('[data-herb-audit]');
          if (!dataNode) throw new Error('Missing herb data');
          const data = JSON.parse(dataNode.textContent);
          if (!Array.isArray(data.products)) throw new Error('Invalid herb data');
          pages = Math.max(1, Number(data.pages) || 1);
          for (const product of data.products) {
            if (!Array.isArray(product.herbs)) continue;
            for (const raw of product.herbs) {
              if (typeof raw !== 'string' || !raw.trim()) continue;
              const label = raw.trim().normalize('NFC');
              const key = label.toLocaleLowerCase(locale);
              if (!groups.has(key)) groups.set(key, { label, values: new Set(), products: new Set() });
              const group = groups.get(key);
              group.values.add(raw);
              group.products.add(product.id);
            }
          }
          page++;
        } while (page <= pages);
        if (!groups.size) throw new Error('No herb values');
        const list = document.createElement('ul');
        list.className = 'motion-herb-directory';
        list.setAttribute('role', 'list');
        const collectionUrl = new URL(this.dataset.source, window.location.origin);
        for (const group of [...groups.values()].sort((a, b) => a.label.localeCompare(b.label, locale))) {
          const item = document.createElement('li');
          const link = document.createElement('a');
          const target = new URL(collectionUrl);
          for (const value of group.values) target.searchParams.append('filter.p.m.custom.herbs', value);
          link.href = target.pathname + target.search;
          const label = document.createElement('span');
          label.textContent = group.label;
          const count = document.createElement('small');
          count.textContent = String(group.products.size);
          link.append(label, count);
          item.append(link);
          list.append(item);
        }
        this.querySelector('[data-herb-list]').replaceChildren(list);
        this.visibleCount = 20;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'button button--secondary motion-herb-load-more';
        button.textContent = locale.split('-')[0] === 'lv' ? 'Ielādēt vēl' : 'Load more';
        button.hidden = true;
        this.append(button);
        this.updateVisibility = () => {
          [...list.children].forEach((item, index) => {
            item.hidden = this.mobileQuery.matches && index >= this.visibleCount;
          });
          button.hidden = !this.mobileQuery.matches || this.visibleCount >= list.children.length;
        };
        button.addEventListener('click', () => {
          const firstNewLink = list.children[this.visibleCount]?.querySelector('a');
          this.visibleCount += 20;
          this.updateVisibility();
          // Keep keyboard focus in the newly revealed batch, even when the button disappears.
          firstNewLink?.focus({ preventScroll: true });
        });
        this.mobileQuery.addEventListener('change', this.updateVisibility);
        this.updateVisibility();
        status.textContent = '';
      } catch {
        status.textContent = this.dataset.error;
      } finally {
        this.setAttribute('aria-busy', 'false');
      }
    }
  });
}
